import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import getCartShippingAmount from '@core/reducers/cart/selectors/getCartShippingAmount';
import getCartMinDeliveryAmount from '@core/reducers/cart/selectors/getCartMinDeliveryAmount';
import getCartDeliveryTimeExpected from '@core/reducers/cart/selectors/getCartDeliveryTimeExpected';
import getShopInformationPickup from '@shopDetails/selectors/getShopInformationPickup';
import getCartIsPickUp from '@core/reducers/cart/selectors/getCartIsPickUp';
import getCartPlusInfo from '@core/reducers/cart/selectors/getCartPlusInfo';
import { getShopInfo } from '@conversion/selectors';
import ShopCard from './ShopCard';

const mapStateToProps = createStructuredSelector({
  cartShippingAmount: getCartShippingAmount,
  cartMinDeliveryAmount: getCartMinDeliveryAmount,
  cartDeliveryTime: getCartDeliveryTimeExpected,
  shop: getShopInfo,
  info: getShopInformationPickup,
  isPickup: getCartIsPickUp,
  plusSettings: getCartPlusInfo,
});

export default connect(mapStateToProps)(ShopCard);
